/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */
/* eslint-disable react/jsx-props-no-spreading */

import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { SkeletonText } from '@carbon/react';

const CodeViewerImpl = lazy(() => import('./CodeViewerImpl'));

export default function CodeViewer(props) {
  return (
    <Suspense fallback={<SkeletonText paragraph />}>
      <CodeViewerImpl {...props} />
    </Suspense>
  );
}

CodeViewer.propTypes = {
  codeLanguage: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
